import { Check, Star } from "lucide-react";
import { Button } from "@/components/ui/button";

const eur = (v) => `€${Number(v).toFixed(2).replace(".", ",")}`;

export const CUSTOM_PLAN = {
  id: "custom",
  name: "Su misura",
  price_label: "Colloquio",
  subtitle: "Si parte da un colloquio, non da un abbonamento.",
  features: ["Per chi vuole che Nadia segua l’attività.", "Una priorità", "Testi e Reel", "Invio solo dopo approvazione", "Un aggiornamento a settimana", "Budget pubblicitario a parte.", "Vedi il lavoro in un’area riservata, con password."],
  cta: "Richiedi un colloquio",
  contact_href: "mailto:support@nadiacloud.it?subject=Richiesta%20colloquio%20-%20Nadia%20Su%20misura",
  whatsapp_cta: "Scrivi su WhatsApp",
  whatsapp_href: "https://wa.me/393533013892?text=Voglio%20Nadia%20Su%20misura",
};

export function PlanCard({ plan, onSelect, busy, current, featured = false }) {
  const pro = featured || !!plan.badge;
  return (
    <div className={`nadia-card p-6 relative flex flex-col h-full ${pro ? "border-violet-500/40 shadow-[0_0_50px_rgba(139,92,246,0.12)]" : ""}`} data-testid={`plan-card-${plan.id}`}>
      {plan.badge && (
        <span className="absolute -top-3 left-6 inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-400 to-violet-500 text-slate-950" data-testid={`plan-badge-${plan.id}`}>
          <Star size={10} strokeWidth={3} /> {plan.badge}
        </span>
      )}
      <div className="font-heading text-xl font-bold text-slate-50">{plan.name}</div>
      <div className="mt-2 flex items-baseline gap-1">
        <span className="font-heading text-4xl font-extrabold text-slate-50" data-testid={`plan-price-${plan.id}`}>{plan.price_label || eur(plan.price_month)}</span>
        {!plan.price_label && <span className="text-sm text-slate-400">/ mese</span>}
      </div>
      <div className="text-sm text-cyan-300 font-semibold mt-1" data-testid={plan.subtitle ? `plan-subtitle-${plan.id}` : `plan-credits-${plan.id}`}>{plan.subtitle || `${plan.credits_month} gettoni / mese`}</div>
      <ul className="mt-4 space-y-1.5 flex-1">
        {(plan.id === "start" || plan.id === "pro") && <li className="flex items-center gap-2 text-sm font-semibold text-emerald-200" data-testid={"plan-unlimited-posts-" + plan.id}><Check size={13} className="text-emerald-400 shrink-0" aria-hidden="true" />Post illimitati</li>}
        {plan.features.filter((f) => !f.startsWith("Ricariche da ")).map((f) => (
          <li key={f} className="flex items-center gap-2 text-sm text-slate-300"><Check size={13} className="text-emerald-400 shrink-0" />{f}</li>
        ))}
      </ul>
      <Button asChild={!!plan.contact_href} onClick={onSelect} disabled={busy || current} className={`mt-5 h-11 shrink-0 font-semibold rounded-xl ${pro ? "bg-gradient-to-r from-cyan-400 to-violet-500 text-slate-950 hover:from-cyan-300 hover:to-violet-400" : "bg-white/[0.06] border border-white/10 text-slate-100 hover:border-cyan-400/50 hover:text-cyan-200"}`} data-testid={`plan-cta-${plan.id}`}>
        {plan.contact_href ? <a href={plan.contact_href}>{plan.cta}</a> : current ? "Piano attivo" : plan.cta}
      </Button>
      {plan.id === "custom" && plan.whatsapp_href && (
        <Button asChild variant="outline" className="mt-2 h-11 shrink-0 font-semibold rounded-xl bg-transparent border-white/10 text-slate-100 hover:border-cyan-400/50 hover:text-cyan-200" data-testid="plan-whatsapp-custom">
          <a href={plan.whatsapp_href} target="_blank" rel="noopener noreferrer">{plan.whatsapp_cta}</a>
        </Button>
      )}
    </div>
  );
}
